import React, { useRef } from "react";
import styled from "styled-components";
import { useAdsense } from "./useAdsense";

const DisplayAds = () => {
  const insRef = useRef(null);
  useAdsense(insRef);

  return (
    <Container>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-5113702954144664"
        data-ad-slot="9562839257"
        data-ad-format="fluid"
        data-full-width-responsive="true"
      ></ins>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;

  aspect-ratio: 700/466;

  border-radius: 16px;
  border: 1px solid var(--light-gray-200, #edeeef);

  cursor: pointer;
`;

export default DisplayAds;
